module.exports = __webpack_public_path__ + "img/logo-mini.ff0cbc84.png";